import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <ContactHero />
        <ContactForm />
        <MapSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
